import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const HeroSkelton = () => {
    return (
        <div>
            <div className='shadow-xl'>
                <SkeletonTheme baseColor="#10171E" highlightColor="#15202B">
                    <Skeleton height={460} style={{ width: '100%' }} />
                </SkeletonTheme>
            </div>
        </div>
    );
};

export default HeroSkelton;